<template>
    <div>
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>

        <div class="row">

            <div class="col-md-12 col-sm-12 loan_transaction_head" >
                <h4 class="loan_transaction_head_sub">
                    <span class="head-1">{{employee_info.name}}</span>
                    <span class="head-2">Loan / Advance Transactions </span>
                    <span  v-if='loan.company_loan_id != ""' class="head-3"> # {{loan.company_loan_id}}</span> <!-- Mustafijur: 19-05-2026: removed : -->
                </h4>
                <span :class="getValueClass(loan_stat_title_2, loan_status)">
                    <span >
                    {{loan_stat_title_2[loan_status]}}
                    </span>
                </span>
            </div>
            <div class="col-md-2 col-sm-12 d-flex align-items-end justify-content-end" >
                <div class="pl-0 pr-2 company-employee-count" style="height: 31px; position: unset;"></div>
            </div>
        </div>

        <div class="row  py-3">
            <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(loan.loan_amount)}}</h3>
                <span>{{total_loan_title}}</span>
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(loan_breakdown.debit_amount)}}</h3>
                <span>Paid Amount</span>
                </div>
                </div>
                </div>
            </div>

            <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(loan_breakdown.remaining_amount)}}</h3>
                <span>Remaining Amount</span>
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;#&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{loan_breakdown.debit_month}} / {{loan.loan_tenure}}</h3>
                <span >Transaction Months</span>
               </div>
                </div>
                </div>
            </div>
        </div>




        <b-overlay rounded="sm">
            <div v-if="transactions.length > 0" class=" p-3">

                <div class="row table-head">
                    <div class="col-sm-2 text-center font-weight-bold py-2">
                        Pay Run Name
                    </div>
                    <div class="col-sm-2 text-center font-weight-bold py-2">
                        Pay Slip Name
                    </div>
                    <div class="col-sm-2 text-center font-weight-bold py-2">
                        Pay Slip file
                    </div>
                    <div class="col-sm-2 text-center font-weight-bold py-2">
                        Amount (BDT)
                    </div>
                    <div class="col-sm-2 text-center font-weight-bold py-2">
                        Type
                    </div>
                    <div class="col-sm-2 text-center font-weight-bold py-2">
                        Month
                    </div>
                </div>

                <div class="row table-row hover-bg" v-for="transaction in transactions" :key="transaction.id">
                    <div class="col-sm-2 py-2 align-items-center d-flex" v-if="transaction.payrun_id >0">
                        <div class="">{{pay_runs[transaction.payrun_id].name}}</div>
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex border-left" v-if="transaction.payrun_id ==0">
                        <div class="">N/A</div>
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex border-left" v-if="transaction.payslip_id >0">
                        <div class=""> {{pay_slips[transaction.payslip_id].pay_slip_name}}</div>
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex border-left" v-if="transaction.payslip_id ==0">
                         <div class="">N/A</div>
                    </div>
                    <div class="col-sm-2 py-2 border-left d-flex align-items-center justify-content-center" v-if="transaction.payslip_id > 0">
                         <b-link @click="downloadPaySlip(transaction.payslip_id,pay_slips[transaction.payslip_id].fiscal_year)">
                            <img :src="$api_url+'/images/download_image.png'"  class="" />
                        </b-link>
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex border-left" v-if="transaction.payslip_id ==0">
                         <div class="">N/A</div>
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex justify-content-end border-left">
                        {{formatMoney(transaction.amount)}}
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex border-left">
                        {{tx_type[transaction.tx_type]}}
                    </div>
                     <div class="col-sm-2 py-1 align-items-center d-flex border-left">
                        {{transaction.month}}
                    </div>

                </div>
            </div>
            <div v-else class=" p-4">
                Sorry no transaction to show.
            </div>
        </b-overlay>
    </div>

</template>
<script>




    export default{

        mounted() {
            setTimeout(this.showContent , 3000);

        },
        props: ['readonly','loan_id'],

        data(){

            return {
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#212529 !important',
                installments:[],
                showoverlay : true,
                cu:window.location.href,

                transactions:[],
                loan:[],
                loan_breakdown:[],
                employee_info:[],
                pay_runs:[],
                pay_slips:[],
                loan_title:'',
                company_title:'',
                total_loan_title:'',
                avatarsrc : null,

                ewtabIndex : 0,
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned"],
                loan_stat_title_2: ["Declined","Applied","Open","Pause/Stopped","Closed"],
                tx_type : ["Manual Payment","Debit","Credit"],
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                loan_type : '',
                action_loader:'',
                modal_title:'',
                count:0,

                loan_status:0,
                is_custom:0,
                is_status:0,
                flg:0,
                loading :'',
                c_flg: 0, // This variable is for reloading public info

            }
        },
        methods:{

            showContent: function()
            {
                this.showoverlay = false;
            },
            getValueClass: function (data, key) {
                var strclass = '';
                strclass = 'status-label status-label-' + data[key].toLowerCase().replace('/', '-');
                return strclass;
            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                axios.get(this.$api_url+'/front/loan-advance/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            // Mustafijur: 24-05-2026: Starts
            // formatMoney: function(amount){
            //     var money = Number(amount);
            //     money = money.toLocaleString();
            //     if(money=='NaN')
            //     money = amount;
            //     else{
            //     if(money.indexOf(".")<0)
            //     money = money+".00";
            //     }
            //     return money;
            // },
            formatMoney: function(amount){
                var money = Number(amount);

                if(this.$atl_company_number_format == 'no')
                {
                    money = Math.round(money);
                    money = money.toLocaleString();
                }
                else
                {
                    money = money.toLocaleString();
                    if(money=='NaN')
                    money = amount;
                    else{
                    if(money.indexOf(".")<0)
                    money = money+".00";
                    }

                }

                return money;
            },
            // Mustafijur: 24-05-2026: Ends
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, '');
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },

            setFormtitle:function(x)
            {
                if(x == 1)
                {
                    this.loan_title = 'Employee Loan Breakdown';
                    this.total_loan_title = 'Total Loan Amount';

                }
                else if(x == 2)
                {
                    this.loan_title = 'Employee Salary Advance Breakdown';
                    this.total_loan_title = 'Total Salary Advance Amount';

                }

            },
            getLoanTransactionData: function(loan_id)
            {

                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('loan_id', loan_id);
                axios.post(this.$api_url+'/front/loan-advance/transactionslist' ,formData).then(function(response){
                    this.transactions = response.data.transactions;
                    this.loan_id = response.data.loan_details.loan_id;
                    this.loan_status = response.data.loan_details.status;

                    this.loan = response.data.loan_details;
                    this.setFormtitle(this.loan.loan_type);
                    this.loan_breakdown = response.data.loan_breakdown;
                    this.employee_info = response.data.employee_info;
                    this.pay_runs = response.data.pay_runs;
                    this.pay_slips = response.data.pay_slips;
                    this.c_flg += 1;

                }.bind(this)).catch(function (error){currentObj.serverError(error);});


            },
            getLoanInstallments: function(loan)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('id', loan);

                this.showoverlay = true;
                axios.post(this.$api_url+'/front/loan-advance/installments', formData)
                    .then(function (response)
                    {
                        this.installments = response.data;
                        this.showoverlay = false;


                    }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            download_file(fileURL, fileName) {
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                save.download = fileName || filename;
        	       if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
        				document.location = save.href;
        			}else{
        		        var evt = new MouseEvent('click', {
        		            'view': window,
        		            'bubbles': true,
        		            'cancelable': false
        		        });
        		        save.dispatchEvent(evt);
        		        (window.URL || window.webkitURL).revokeObjectURL(save.href);
        			}
            }
            else if ( !! window.ActiveXObject && document.execCommand)     {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
           },
            downloadPaySlip: function(p_slip,f_year,email_file=false,prnt_file=false)
			  {
				     this.action_loader = true;
                     var send_file = email_file ? 1: 0;
                     const config = {
                      headers: { 'Content-Type': 'application/json; charset=utf-8', },
                      responseType: 'blob',
                    }
                    axios.get(this.$api_url+'/front/payslippdf/'+f_year+'/'+p_slip ,config, {
							  params: {
							     em_file:  send_file
							  }
					  }).then(function(response){

                        this.action_loader = false;
                        if(response.data.type =='application/json')
                        {
                            let file = new Blob([response.data], {type: 'application/json'});
                            /* if you use different error message just change the name instead of  'error_msg' */
                            const cast = Promise.resolve(file.text());
                            cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            currentObj.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                            });
                        }
                        else
                        {
                            this.global_download_file_content(response);
                        }

                      //console.log(response.data.file_name);
				  }.bind(this));
		     },
        },
        created: function(){
            this.updateTransactions();
			this.getLoanTransactionData(this.loan_id);

        }

    }

</script>
